export type MenuAnalyticsTimeRange = "today" | "thisWeek" | "lastWeek" | "thisMonth" | "lastMonth" | "custom";
export type MenuAnalyticsMealPeriod = "all" | "breakfast" | "lunch" | "dinner" | "snack";
export type MenuItemsSortField =
  | "rank"
  | "name"
  | "mealType"
  | "averageRating"
  | "totalOrders"
  | "users"
  | "avgOrderPerUser"
  | "trend";
export type SortDirection = "asc" | "desc";

export type TrendValue = number | "N/A" | "New";

export interface AnalyticsDateRange {
  start: string;
  end: string;
}

export interface MenuItemAnalyticsRow {
  id: string;
  rank: number;
  name: string;
  mealType: string;
  averageRating: number | null;
  totalOrders: number;
  users: number;
  avgOrderPerUser: number;
  previousOrders: number;
  trendPercent: TrendValue;
}

export interface PerformerRef {
  name: string;
  orders: number;
  tiedNames?: string[];
}

export interface MenuItemsAnalyticsSummary {
  totalOrders: number;
  uniqueUsers: number;
  avgOrdersPerAthlete: number;
  topPerformer: PerformerRef | null;
  lowPerformer: PerformerRef | null;
}

export interface MenuItemsAnalyticsMeta {
  lastUpdated: string;
  page: number;
  pageSize: number;
  totalCount: number;
  totalPages: number;
  range: AnalyticsDateRange;
}

export interface MenuItemsAnalyticsResponse {
  summary: MenuItemsAnalyticsSummary;
  items: MenuItemAnalyticsRow[];
  meta: MenuItemsAnalyticsMeta;
}

export type IngredientsSortField = "rank" | "name" | "totalGramsServed" | "trend";

export type WeightUnit = "lb" | "kg";

export interface IngredientAnalyticsRow {
  id: string;
  rank: number;
  name: string;
  unit: string;
  totalGramsServed: number; 
  previousGramsServed: number; 
  trendPercent: TrendValue;
}

export interface IngredientsAnalyticsMeta {
  lastUpdated: string;
  page: number;
  pageSize: number;
  totalCount: number;
  totalPages: number;
  range: AnalyticsDateRange;
}

export interface IngredientsAnalyticsResponse {
  items: IngredientAnalyticsRow[];
  meta: IngredientsAnalyticsMeta;
}

export const PAGE_SIZE_OPTIONS = [10, 25, 50, 100];
export const DEFAULT_PAGE_SIZE = 50;
export const MAX_CUSTOM_RANGE_MONTHS = 12;
